import { render, staticRenderFns } from "./SettledScroll.vue?vue&type=template&id=61b4b7b5&scoped=true&"
import script from "./SettledScroll.vue?vue&type=script&lang=js&"
export * from "./SettledScroll.vue?vue&type=script&lang=js&"
import style0 from "./SettledScroll.vue?vue&type=style&index=0&id=61b4b7b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b4b7b5",
  null
  
)

export default component.exports